import React from "react";

const HeadButton = ({
  label,
  labelFontSize = "1.75rem",
  lineWidth = "6rem",
  lineHeight = "2px",
  color = "#1a1443",
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <span
        style={{
          width: lineWidth,
          height: lineHeight,
          backgroundColor: color,
        }}
      ></span>

      <span
        style={{
          backgroundColor: color,
          color: "white",
          padding: "5px 7px",
          fontSize: labelFontSize,
          borderRadius: "0.375rem",
        }}
      >
        {label}
      </span>

      <span
        style={{
          width: lineWidth,
          height: lineHeight,
          backgroundColor: color,
        }}
      ></span>
    </div>
  );
};

export default HeadButton;
